export class Lobby {
  constructor(ctx) {
    this.ctx = ctx;
    this.root = null;
    this._offs = [];
    this._open = false;
    this._joining = false;
    this._warnedAuth = false;
    this._build();
  }

  async init() {
    const events = this.ctx?.events;
    const EVENTS = this.ctx?.EVENTS;

    if (events?.on && EVENTS?.NET_STATUS) {
      this._offs.push(events.on(EVENTS.NET_STATUS, (payload) => this._onNetStatus(payload)));
    }
    if (events?.on && EVENTS?.AUTH_CHANGED) {
      this._offs.push(events.on(EVENTS.AUTH_CHANGED, ({ user } = {}) => this._onAuthChanged(user)));
    }

    this._onKeyDown = (event) => {
      if (!this._open || event.code !== 'Escape') return;
      event.preventDefault();
      this.close();
    };
    window.addEventListener('keydown', this._onKeyDown);
  }

  open() {
    if (!this.ctx?.session?.isLoggedIn) {
      this.close();
      this._openAuth();
      return;
    }

    this._open = true;
    this.root.hidden = false;
    this.root.classList.add('open');
    this._updateAccount();
    this._clearError();
    void this._loadRanking();
  }

  close() {
    this._open = false;
    this.root?.classList?.remove?.('open');
    if (this.root) this.root.hidden = true;
  }

  dispose() {
    for (const off of this._offs) off?.();
    this._offs.length = 0;
    if (this._onKeyDown) window.removeEventListener('keydown', this._onKeyDown);
    this.root?.remove?.();
    this.root = null;
  }

  _build() {
    const root = document.createElement('div');
    root.className = 'net-screen';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'lobby-title');

    const panel = document.createElement('div');
    panel.className = 'net-panel';
    root.appendChild(panel);

    const eyebrow = document.createElement('div');
    eyebrow.className = 'net-sub';
    eyebrow.textContent = 'OPERA\u00c7\u00c3O ONLINE';
    panel.appendChild(eyebrow);

    const title = document.createElement('h2');
    title.id = 'lobby-title';
    title.className = 'net-title';
    title.textContent = 'MULTIJOGADOR';
    panel.appendChild(title);

    const playerRow = document.createElement('div');
    playerRow.className = 'net-row';
    panel.appendChild(playerRow);

    this.nickname = document.createElement('strong');
    this.nickname.className = 'net-sub';
    playerRow.appendChild(this.nickname);

    this.ranking = document.createElement('span');
    this.ranking.className = 'net-badge';
    this.ranking.textContent = 'RANKING: --';
    playerRow.appendChild(this.ranking);

    const connectionRow = document.createElement('div');
    connectionRow.className = 'net-status';
    panel.appendChild(connectionRow);

    const connectionLabel = document.createElement('span');
    connectionLabel.textContent = 'CONEX\u00c3O';
    connectionRow.appendChild(connectionLabel);

    this.connection = document.createElement('span');
    this.connection.className = 'net-badge';
    this.connection.textContent = 'DESCONECTADO';
    this.connection.dataset.state = 'offline';
    connectionRow.appendChild(this.connection);

    this.error = document.createElement('div');
    this.error.className = 'net-error';
    this.error.setAttribute('role', 'alert');
    this.error.hidden = true;
    panel.appendChild(this.error);

    const form = document.createElement('form');
    form.className = 'net-form';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      void this._joinRoom();
    });
    panel.appendChild(form);

    const field = document.createElement('div');
    field.className = 'net-field';
    form.appendChild(field);

    const roomLabel = document.createElement('label');
    roomLabel.className = 'net-label';
    roomLabel.htmlFor = 'lobby-room';
    roomLabel.textContent = 'C\u00d3DIGO DA SALA (OPCIONAL)';
    field.appendChild(roomLabel);

    this.roomInput = document.createElement('input');
    this.roomInput.id = 'lobby-room';
    this.roomInput.name = 'room';
    this.roomInput.type = 'text';
    this.roomInput.autocomplete = 'off';
    this.roomInput.className = 'net-input';
    field.appendChild(this.roomInput);

    const roomActions = document.createElement('div');
    roomActions.className = 'net-actions';
    form.appendChild(roomActions);

    this.roomButton = document.createElement('button');
    this.roomButton.type = 'submit';
    this.roomButton.className = 'btn';
    this.roomButton.textContent = 'ENTRAR COM C\u00d3DIGO';
    roomActions.appendChild(this.roomButton);

    const actions = document.createElement('div');
    actions.className = 'net-actions';
    panel.appendChild(actions);

    this.autoButton = document.createElement('button');
    this.autoButton.type = 'button';
    this.autoButton.className = 'btn primary btn-primary';
    this.autoButton.textContent = 'ENTRAR NA PARTIDA';
    this.autoButton.addEventListener('click', () => void this._join(null, this.autoButton));
    actions.appendChild(this.autoButton);

    const rankingButton = document.createElement('button');
    rankingButton.type = 'button';
    rankingButton.className = 'btn';
    rankingButton.textContent = 'VER RANKING';
    rankingButton.addEventListener('click', () => {
      this.close();
      this.ctx?.events?.emit?.('ui:openRanking');
    });
    actions.appendChild(rankingButton);

    const logoutButton = document.createElement('button');
    logoutButton.type = 'button';
    logoutButton.className = 'btn';
    logoutButton.textContent = 'SAIR DA CONTA';
    logoutButton.addEventListener('click', () => {
      this.ctx?.session?.clear?.();
      this.close();
    });
    actions.appendChild(logoutButton);

    const backButton = document.createElement('button');
    backButton.type = 'button';
    backButton.className = 'btn ghost';
    backButton.textContent = 'VOLTAR';
    backButton.addEventListener('click', () => this.close());
    actions.appendChild(backButton);

    (document.getElementById('ui-root') || document.body).appendChild(root);
    this.root = root;
  }

  _openAuth() {
    const auth = this.ctx?.authScreen || this.ctx?.auth;
    if (auth?.open) {
      auth.open('login');
      return;
    }
    if (!this._warnedAuth) {
      this._warnedAuth = true;
      console.warn('[Lobby] AuthScreen nao esta disponivel no contexto.');
    }
  }

  _onAuthChanged(user) {
    if (!user) {
      if (this._open) this.close();
      return;
    }
    if (this._open) {
      this._updateAccount();
      void this._loadRanking();
    }
  }

  _updateAccount() {
    const user = this.ctx?.session?.user;
    this.nickname.textContent = user?.nickname ? `OPERADOR: ${user.nickname}` : 'OPERADOR';
  }

  async _loadRanking() {
    this.ranking.textContent = 'RANKING: CARREGANDO...';
    try {
      const row = await (this.ctx?.session?.api || this.ctx?.api)?.myRanking?.();
      if (!this._open) return;
      this.ranking.textContent = Number.isFinite(row?.position)
        ? `RANKING: #${row.position}`
        : 'RANKING: SEM PARTIDAS';
    } catch (err) {
      if (!this._open) return;
      this.ranking.textContent = 'RANKING: INDISPON\u00cdVEL';
      this._setError(err?.message || 'N\u00c3O FOI POSS\u00cdVEL CONSULTAR O RANKING.');
    }
  }

  _onNetStatus(payload) {
    const state = payload?.state || 'offline';
    const labels = {
      offline: 'DESCONECTADO',
      connecting: 'CONECTANDO...',
      online: 'CONECTADO',
      error: 'ERRO DE CONEX\u00c3O'
    };
    this.connection.textContent = labels[state] || String(state).toUpperCase();
    this.connection.dataset.state = state;
    if (state === 'error' && payload?.message) this._setError(payload.message);
  }

  async _joinRoom() {
    const code = this.roomInput?.value?.trim?.() || '';
    if (!code) {
      this._setError('INFORME O C\u00d3DIGO DA SALA.');
      this.roomInput?.focus?.();
      return;
    }
    await this._join(code, this.roomButton);
  }

  async _join(room, sourceButton) {
    if (this._joining) return;
    const joinMatch = this.ctx?.match?.joinMatch;
    if (typeof joinMatch !== 'function') {
      this._setError('O SERVI\u00c7O DE PARTIDA N\u00c3O EST\u00c1 DISPON\u00cdVEL.');
      return;
    }

    this._joining = true;
    this._clearError();
    this.autoButton.disabled = true;
    this.roomButton.disabled = true;
    const originalLabel = sourceButton.textContent;
    sourceButton.textContent = 'CONECTANDO...';

    try {
      // Pointer lock TEM que sair de dentro do gesto do clique: o navegador
      // recusa o pedido feito depois de um await (deixa de ser "gesto do
      // usuario"). Pedir aqui e o que garante mira e tiro no desktop.
      if (!this.ctx?.input?.touchActive && !this.ctx?.touch?.supported) {
        this.ctx?.input?.requestLock?.();
      }
      const joined = await this.ctx?.match?.joinMatch?.(room);
      if (!joined) {
        this._setError(this.ctx?.match?.lastReason || 'N\u00c3O FOI POSS\u00cdVEL ENTRAR NA PARTIDA.');
        return;
      }
      this.close();
    } catch (err) {
      this._setError(err?.message || 'N\u00c3O FOI POSS\u00cdVEL ENTRAR NA PARTIDA.');
    } finally {
      this._joining = false;
      this.autoButton.disabled = false;
      this.roomButton.disabled = false;
      sourceButton.textContent = originalLabel;
    }
  }

  _clearError() {
    this.error.textContent = '';
    this.error.hidden = true;
  }

  _setError(message) {
    this.error.textContent = message;
    this.error.hidden = false;
  }
}
